export const toTitleCase = (str: string | undefined | null) => {
  if (!str || str.length < 1) {
    return "";
  }

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
